/** Eternal City copy, zh-CN. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityZhCN: Record<string, string> = {
  'city.seoDescription': '走进一个活着的城市,每个人都遵守日常规律,跟随他们,和他们聊天,和那些没有你的人一起度过一天.',
  'city.intro': '一个活着的城市. 这里的每个人都保持日常生活,时间随着你的玩法而过去了.',
  'city.back': '返回地球',
  'city.connecting': '打开城市的门...',
  'city.reconnecting': '丢了线索,重新连接...',
  'city.offline': '现在这个城市无法到达,请再试一下.',
  'city.signinTitle': '登录',
  'city.signinBody': '你在城市的位置,你的日志和你遇到的人都被保存给你的账户.',
  'city.signinCta': '登录',
  'city.privacy': '我们如何处理这些数据:隐私政策',
  'city.blocked': '如果您认为这是一个错误,请联系支持.',
  'city.openElsewhere': '这座城市又开放了,关掉那个,或者重新加载这里.',
  'city.canvasLabel': '的同位数地图 {city}. 用旁边的列表来聊天,散步,看周围.',
  'city.hint': '单击地面,以走路,或单击一个人,以说话.',
  'city.holiday': '今天: {name}',
  'city.here': '你在 {place}.',
  'city.commons.empty': '这是一个共享空间,现在没有其他旅行者.',
  'city.commons.here.one': '这是一个共享空间,另一个旅行者在这里.',
  'city.commons.here.other': '这是一个共享空间, {count} 其他旅行者也在这里.',
  'city.commons.peer': '一位同行',
  'city.crowd.name': '城市居民',
  'city.travel.ride': '骑到 {place} (约为 {n} 时间:',
  'city.wares.now': '现在说: {list}',
  'city.wares.none': '没有什么时间.',
  'city.wares.few': '{name} (剩下几个)',
  'city.wares.last': '{name} (最后一个)',
  'city.places': '去一个地方.',
  'city.goPlace': '走去 {place}',
  'city.dialogueAnnounce': '随着它们的出现,就会宣布选择.',
  'city.people': '谁在周围',
  'city.peopleNone': '没有人看到.',
  'city.talk': '谈话',
  'city.goto': '走过去',
  'city.away': '{n} 走走',
  'city.scenes': '发生在附近',
  'city.watch': '加入我们',
  'city.props': '周围看看',
  'city.examine': '看看.',
  'city.open': '开放',
  'city.take': '接下来',
  'city.menu.open': '开放 {thing}',
  'city.menu.take': '拿到里面的东西 {thing}',
  'city.menu.walkToThing': '走到这里 {thing}',
  'city.dialogue': '谈话',
  'city.close': '接近',
  'city.leave': '离开谈话',
  'city.menu.talk': '谈谈 {name}',
  'city.menu.walkTalk': '走到这里 {name}',
  'city.menu.walkTo': '走到这里 {name}',
  'city.menu.walkHere': '走在这里.',
  'city.menu.swimHere': '在这里游泳',
  'city.menu.rowHere': '排在这里',
  'city.mount.down': '走下来. {name}',
  'city.companion.home': '发送 {name} 家庭',
  'city.rumours.title': '传言板',
  'city.rumours.none': '站在城镇的人一起聊天,在酒吧上,他们所说的东西是卡在这里.',
  'city.rumours.said': '他说 {name}',
  'city.greet.title': '已知名字',
  'city.greet.callMe': '城市人叫你什么',
  'city.greet.placeholder': '你的名字',
  'city.greet.none': '现在没有人认识你,你就跟别人说话,下次他们会以名字问你.',
  'city.greet.morning.0': '早晨, {name}!',
  'city.greet.morning.1': '您的早晨好, {name}.',
  'city.greet.morning.2': '起床很早, {name}?',
  'city.greet.afternoon.0': '晚上好好, {name}.',
  'city.greet.afternoon.1': '您好. {name}!',
  'city.greet.afternoon.2': '再见了, {name}.',
  'city.greet.evening.0': '晚上, {name}.',
  'city.greet.evening.1': '晚上好, {name}!',
  'city.greet.evening.2': '离开家, {name}?',
  'city.greet.night.0': '晚上出门, {name}.',
  'city.greet.night.1': '警黑暗, {name}.',
  'city.greet.night.2': '现在还在, {name}?',
  'city.greet.morning.0.anon': '您好,朋友!',
  'city.greet.morning.1.anon': '您的早晨好.',
  'city.greet.morning.2.anon': '早起了,朋友?',
  'city.greet.afternoon.0.anon': '晚上好好,朋友.',
  'city.greet.afternoon.1.anon': '祝你一个好日子!',
  'city.greet.afternoon.2.anon': '很好再次见面.',
  'city.greet.evening.0.anon': '晚上,朋友.',
  'city.greet.evening.1.anon': '晚上好!',
  'city.greet.evening.2.anon': '在家里,朋友?',
  'city.greet.night.0.anon': '太晚了,朋友.',
  'city.greet.night.1.anon': '注意黑暗.',
  'city.greet.night.2.anon': '还在,朋友?',
  'city.market.title': '市场板',
  'city.market.shut': '现在没有什么.',
  'city.market.later': '今天晚些时候:',
  'city.market.am': '{n} 在早晨',
  'city.market.pm': '{n} 在下午',
  'city.market.eve': '{n} 在晚上',
  'city.garden.title': '园林地块',
  'city.garden.tend': '关心这个情节',
  'city.garden.tended': '你把一些杂草拉出来,灌地块.',
  'city.garden.already': '今天你已经处理了这个阴谋.',
  'city.garden.tendedNote': '今天',
  'city.garden.arrive': '其他 {crop} 这里是 {stage}.',
  'city.garden.crop.herbs': '草药',
  'city.garden.crop.apples': '果树',
  'city.garden.crop.kitchen': '厨房绿色',
  'city.garden.crop.cabbages': '菜和豆类',
  'city.garden.crop.wheat': '麦田',
  'city.garden.stage.bare': '在冬季',
  'city.garden.stage.sown': '新种植',
  'city.garden.stage.sprouting': '发芽',
  'city.garden.stage.growing': '长得很好',
  'city.garden.stage.flowering': '在花中',
  'city.garden.stage.ripe': '成熟和准备好',
  'city.garden.stage.harvested': '收获该年',
  'city.fish.title': '渔业',
  'city.fish.cast': '打一条线',
  'city.fish.go': '走吧.',
  'city.fish.here': '一个很好的捕鱼场地.',
  'city.fish.casting': '你排一排,然后等.',
  'city.fish.caught': '什么东西咬着,你着陆了. {fish}.',
  'city.fish.got.boot': '你把旧的靴子卷回来,然后扔回去.',
  'city.fish.got.weed': '这一次只有河流草.',
  'city.fish.got.nothing': '没有什么咬人,水保留了自己的秘密.',
  'city.fish.casts': '{n} 到目前为止',
  'city.fish.none': '鱼最好在黎明和,更多的春天和秋天.',
  'city.fish.spot.bank': '河岸',
  'city.fish.spot.jetty': '站',
  'city.fish.spot.bridge': '磨坊桥',
  'city.fish.name.perch': '一个子',
  'city.fish.name.roach': '一个',
  'city.fish.name.trout': '一只鱼',
  'city.fish.name.eel': '一个',
  'city.fish.name.pike': '一个子',
  'city.fish.name.carp': '一个鱼',
  'city.fish.name.minnow': '一个小',
  'city.fish.name.crayfish': '一个鱼',
  'city.fish.name.boot': '一个旧的靴子',
  'city.fish.name.weed': '河草',
  'city.fish.name.nothing': '没有什么',
  'city.lost.title': '丢失和发现',
  'city.lost.none': '现在还没有找到任何东西. 镇人把东西扔在市场,广场和其他繁忙的地方.',
  'city.lost.whose': '属于 {name}',
  'city.lost.find': '找到 {name}',
  'city.lost.spot': '这里有什么东西躺在地上: {thing}',
  'city.lost.pick': '接下来 {thing}',
  'city.lost.picked': '你接下来 {thing}. 看起来它属于 {name}.',
  'city.lost.give': '给一个人 {thing} 回到 {name}',
  'city.lost.thanks': '{name} 我很高兴 {thing} 回来吧.',
  'city.lost.thing.glove': '一个丢失的手套',
  'city.lost.thing.keys': '一个钥匙圈',
  'city.lost.thing.locket': '一个小奖牌',
  'city.lost.thing.toy': '一个木制玩具',
  'city.lost.thing.scarf': '一个羊毛巾',
  'city.lost.thing.purse': '一个空的钱包',
  'city.lost.thing.spectacles': '一双眼镜',
  'city.lost.thing.letter': '一封折叠的信',
  'city.lost.thing.ribbon': '一条毛带',
  'city.lost.thing.pipe': '一个粘土管',
  'city.records.title': '城市记录',
  'city.records.peak': '今天最忙于 {time}, 在 {n} 城里的人都在外面.',
  'city.records.now': '这时: {out}外出, {home}在家里.',
  'city.records.busiest': '最繁忙的地区: {district}.',
  'city.records.outTitle': '城镇人,每小时',
  'city.records.seenTitle': '你周围看到的人,每小时',
  'city.a11y.title': '获取性',
  'city.a11y.text': '文本尺寸',
  'city.a11y.size1': '正常的',
  'city.a11y.size125': '大型',
  'city.a11y.size15': '最大的',
  'city.a11y.stillOff': '减少运动',
  'city.a11y.stillOn': '减轻的提议',
  'city.a11y.contrastOff': '高对比度',
  'city.a11y.contrastOn': '高对比性',
  'city.tour.welcome.title': '欢迎来到 {city}',
  'city.tour.welcome.body': '这座城市有自己的时钟.人们醒来,工作,吃饭,睡觉,无论你看着还是不看.',
  'city.tour.walk.title': '步行',
  'city.tour.walk.body': '你的机器人可以通过墙壁和门找到自己的路.',
  'city.tour.talk.title': '谈话',
  'city.tour.talk.body': '一旦你接近,再点击一个人,然后说话.他们的话会在他们的头边出现.',
  'city.tour.menu.title': '我看得更近.',
  'city.tour.menu.body': '在电脑上,右键点击任何东西,看看你可以在那里做什么,例如阅读一个标志,坐下来或预定一个房间.',
  'city.tour.map.title': '最低地图',
  'city.tour.map.body': '角落上的小地图显示了你附近的道路,地区和人.',
  'city.tour.panel.title': '你的面板',
  'city.tour.panel.body': '在手机上,用显示面板按打开.',
  'city.tour.keys.title': '移动',
  'city.tour.keys.body': '在电话上,你可以从那里启动动动作板.',
  'city.tour.done.title': '这就是一切.',
  'city.tour.done.body': '享受 {city}. 你可以从侧面板上再次进行这次巡视.',
  'city.tour.step': '{n} 的 {total}',
  'city.tour.next': '接下来',
  'city.tour.back': '返回',
  'city.tour.skip': '跳过巡回演出',
  'city.tour.finish': '开始探索',
  'city.tour.again': '再一次参观城市.',
  'city.found.title': '发现的地点',
  'city.found.count': '{n} 的 {total}',
  'city.found.none': '走进一个地方,把它添加到这里.',
  'city.found.new': '发现 {place}',
  'city.board.open': '阅读公开的笔记板',
  'city.board.hint': '其他旅行者留下来的笔记. 住一个短的笔记,没有链接,',
  'city.board.placeholder': '写一封短信,让别人找到',
  'city.board.pin': '上这张笔记',
  'city.board.loading': '阅读板上...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': '写下你的笔记',
  'city.board.err.signin': '登录给我一个笔记.',
  'city.board.err.soon': '在上另一个笔记之前等一点.',
  'city.board.err.bad': '笔记必须是纯文本,最长200个字符,没有链接.',
  'city.board.err.down': '现在不能联系董事会.',
  'city.room.rent': '给我一个房间. {place}',
  'city.room.move': '移动你的房间到 {place}',
  'city.room.yours': '你的房间在 {place}',
  'city.room.decorate': '设置一些东西.',
  'city.room.remove': '拿走了 {thing}',
  'city.room.leave': '放弃你的房间',
  'city.room.full': '你的房间没有更多的空间.',
  'city.room.pickTitle': '装饰你的房间',
  'city.room.pickHint': '在这个位置上设置某种东西,它会留在你的房间里.',
  'city.room.kind.rug': '织成的地毯',
  'city.room.kind.candle': '一个',
  'city.room.kind.flowers': '一个花盆',
  'city.room.kind.painting': '一幅画',
  'city.room.kind.plant': '一个的植物',
  'city.room.kind.chest': '一个小的胸部.',
  'city.room.kind.lantern': '一个灯塔',
  'city.room.kind.books': '几本书',
  'city.busk.lute': '{name} 在附近起一个亮的声音.',
  'city.busk.fiddle': '{name} 在附近的子里,出一个活的子.',
  'city.busk.pipe': '{name} 在附近的空气中播放缓慢.',
  'city.busk.drum': '{name} 在附近跳舞.',
  'city.tail.label': '接下来 {name}',
  'city.tail.title': '排尾 {name} 在一天中',
  'city.tail.now': '现在: {activity} 在 {place}',
  'city.tail.unknown': '他们目前的计划是未知的.',
  'city.tail.next': '接下来: {place} 在 {time}, 在 {h} h {m} 分钟',
  'city.tail.trail': '通过: {places}',
  'city.tail.stop': '停止跟踪',
  'city.pins.add': '添加一个',
  'city.pins.tapMap': '按图,定位你的针头',
  'city.pins.walk': '走到这个脚',
  'city.pins.note': '在 {x}, {y} 点点点.',
  'city.pins.noteLabel': '标记',
  'city.pins.remove': '移除这个针头',
  'city.pins.here': '在地图上贴上这个位置',
  'city.compass.north': '北方',
  'city.compass.at': 'x {x}, y {y}, 楼层 {floor}',
  'city.door.prop': '紧紧打开门',
  'city.door.close': '让这扇门闭上',
  'city.door.unlock': '打开门',
  'city.door.lock': '锁上门',
  'city.books.browse': '浏览货架',
  'city.books.shelf': '货架在 {place}',
  'city.books.book': '书籍',
  'city.books.scroll': '滚动',
  'city.books.prev': '上一篇:',
  'city.books.back': '回到货架上',
  'city.books.next': '接下来',
  'city.books.page': '页面 {n} 的 {of}',
  'city.sign.readSign': '阅读标志',
  'city.sign.readPlaque': '阅读牌子',
  'city.sign.sign': '一个油漆的标志',
  'city.sign.plaque': '门边有一个牌子.',
  'city.district.entering': '现在进入',
  'city.district.riverside': '河边和低市场',
  'city.district.sunwalk': '太阳步行',
  'city.district.lanes': '路线',
  'city.district.monastery': '修道院',
  'city.district.castle': '城堡',
  'city.district.drains': '旧的排水道',
  'city.district.farmlands': '农田',
  'city.photo.enter': '照片模式',
  'city.photo.hint': '随着照片的转移,我们可以在图片中查看.',
  'city.photo.leave': '离开照片模式',
  'city.building.who': '谁生活和工作在 {place}',
  'city.building.live': '他住在这里.',
  'city.building.work': '在这里工作.',
  'city.building.now': '在里面.',
  'city.building.rooms': '接收 {list}.',
  'city.inspect.about': '关于 {name}',
  'city.inspect.close': '接近',
  'city.inspect.unknown': '没有人能告诉你很多关于 {name}.',
  'city.inspect.home': '家庭',
  'city.inspect.work': '工作',
  'city.inspect.none': '没有人知道',
  'city.inspect.today': '今天',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': '追随 {name} 在一天中',
  'city.overlay.label': '地图覆盖',
  'city.overlay.crowd': '群众',
  'city.overlay.light': '灯光',
  'city.overlay.noise': '噪音',
  'city.bar.pop': '{n} 住在这里',
  'city.bar.out': '{n} 现在出去',
  'city.bar.season.spring': '春季',
  'city.bar.season.summer': '夏季',
  'city.bar.season.autumn': '秋季',
  'city.bar.season.winter': '冬季',
  'city.notebook.title': '听到和学习',
  'city.notebook.all': '所有的',
  'city.notebook.heard': '我听说过',
  'city.notebook.learned': '学习',
  'city.notebook.search': '查看你的笔记',
  'city.notebook.none': '在街上倾听,和人们交谈.',
  'city.ask.title': '问问周围',
  'city.ask.pick': '你在找谁?',
  'city.ask.ask': '问问',
  'city.ask.passerby': '一个经过的人',
  'city.ask.nobody': '在街上找别人.',
  'city.ask.unseen': '{asker} 没有看到 {who} 关于今天.',
  'city.ask.here': '{asker} 说 {who} 很近. {place}.',
  'city.ask.go': '走去 {who}',
  'city.weather.clear': '清晰的天空',
  'city.weather.cloudy.light': '一些云',
  'city.weather.cloudy.heavy': '灰色和云层',
  'city.weather.rain.light': '轻微的雨',
  'city.weather.rain.heavy': '大雨',
  'city.weather.fog.light': '清晨的雾',
  'city.weather.fog.heavy': '厚雾',
  'city.weather.snow.light': '轻雪',
  'city.weather.snow.heavy': '沉重的雪',
  'city.lamplighter.name': '灯光照明器',
  'city.lamplighter.lighting': '照明街灯',
  'city.lamplighter.dousing': '关闭街灯',
  'city.hourglass.title': '砂钟',
  'city.hourglass.stop': '停止这一天',
  'city.hourglass.paused': '这一天就停了下来了.',
  'city.hourglass.resume': '继续下去.',
  'city.seat.bench': '子',
  'city.seat.chair': '椅子',
  'city.seat.sit': '坐下来. {what}',
  'city.inside.crate': '箱子',
  'city.inside.barrel': '桶',
  'city.inside.title': '在内部 {what}',
  'city.inside.look': '查看 {what}',
  'city.inside.holds': '这就是 {fill}: {list}.',
  'city.factions.title': '在城市里站着',
  'city.factions.wary': '警',
  'city.factions.unknown': '不知名',
  'city.factions.noticed': '发现',
  'city.factions.trusted': '值得信任',
  'city.factions.honored': '荣誉',
  'city.factions.done': '完成任务: {n}.',
  'city.mail.title': '书信',
  'city.mail.none': '没有信件.',
  'city.mail.from': '通过 {name}',
  'city.mail.waiting': '在等待来自 {names}.',
  'city.mail.nobody': '帮助别人做事,你可以给他们写信.',
  'city.mail.write': '写一封信',
  'city.mail.to': '给谁',
  'city.mail.subject': '主题',
  'city.mail.body': '你的信',
  'city.mail.send': '发送它.',
  'city.mail.untitled': '几行',
  'city.moth.title': '的托盘',
  'city.moth.trade': '给我一个好事.',
  'city.moth.yours': '现在是你的.',
  'city.spy.title': '静静的工作',
  'city.cut.skip': '跳过',
  'city.party.title': '我们一起玩',
  'city.party.blurb': '开始一个聚会,与朋友分享它的代码.',
  'city.party.start': '开始一个聚会',
  'city.party.codeLabel': '党代码',
  'city.party.join': '加入',
  'city.party.bad': '一个党代码是四到八个字母或数字.',
  'city.party.code': '你的党代码是 {code}. 分享给朋友,让他们加入.',
  'city.party.alone': '现在,你党的其他人都没有在城市.',
  'city.party.here': '在你身边',
  'city.party.away': '{n} 步伐 {dir}',
  'city.party.floor': '(地板) {n})',
  'city.party.go': '走去',
  'city.party.leave': '离开这个聚会',
  'city.party.dir.east': '东部',
  'city.party.dir.south-east': '东南',
  'city.party.dir.south': '南方',
  'city.party.dir.south-west': '西南',
  'city.party.dir.west': '西部',
  'city.party.dir.north-west': '西北',
  'city.party.dir.north': '北方',
  'city.party.dir.north-east': '东北',
  'city.print.title': '打印一个建筑物',
  'city.print.here': '{name}: {w} 通过 {d} 电池,地板: {n}. 保存为3D打印机的STL.',
  'city.print.none': '站在建筑物旁边,保存它作为3D打印机的STL.',
  'city.print.model': '保存STL,模型尺度 (每细胞5mm)',
  'city.print.tabletop': '保存STL,桌面尺度 (每细胞一英寸)',
  'city.print.note': '城市画的墙壁,地板,门,楼梯和窗户,',
  'city.print.models': '图像和道具,准备打印:',
  'city.print.busy': '准备...',
  'city.print.model.figure': '步行员形状,在25mm的底部上28mm',
  'city.print.model.fountain': '喷泉,直径3英寸',
  'city.print.model.castle-wall': '城堡墙段,长3英寸',
  'city.editor.stl': '保存STL',
  'city.editor.title': '城市地图编辑器',
  'city.editor.blurb': '绘制一个城市地图的地板按地板:墙壁,街道,门,水,楼梯和命名的地方.下面的检查将其用居住城市使用的地图阅读器读取.您的草图在这个浏览器中保存;将其作为存储或共享的文件出口.',
  'city.editor.name': '地图名称',
  'city.editor.tools': '工具',
  'city.editor.tool.pen': '笔',
  'city.editor.tool.rect': '区块',
  'city.editor.tool.room': '房间',
  'city.editor.tool.fill': '填充',
  'city.editor.tool.spawn': '起点',
  'city.editor.tiles': '土地',
  'city.editor.letter': '一封信',
  'city.editor.placeName': '地方名称',
  'city.editor.addPlace': '增加空间',
  'city.editor.placeBad': '一个地方需要一个字母和一个名字.',
  'city.editor.floors': '楼层',
  'city.editor.addFloor': '添加地板',
  'city.editor.map': '地图',
  'city.editor.width': '宽度',
  'city.editor.height': '高度',
  'city.editor.new': '新地图',
  'city.editor.undo': '无效',
  'city.editor.export': '出口',
  'city.editor.import': '进口',
  'city.editor.loaded': '卡片装满.',
  'city.editor.zoom': '放大',
  'city.editor.check': '检查',
  'city.editor.ok': '读得很清晰. {walk} 开放的细胞, {reach} 从起点可到达.',
  'city.editor.placeSpots': '{name}: {n} 细胞',
  'city.editor.canvas': '图纸画',
  'city.spy.take': '接下来',
  'city.spy.again': '再试一次',
  'city.spy.drop': '放弃它',
  'city.spy.progress': '{n} 百分之百.',
  'city.spy.carrying': '你有那个信件.',
  'city.spy.underway': '在路上.',
  'city.spy.done': '完成了.',
  'city.spy.failed': '上一次是错误的.',
  'city.menu.look': '看看. {thing}',
  'city.menu.street': '在街上',
  'city.menu.wall': '一个墙',
  'city.continue': '继续',
  'city.goodbye': '见面.',
  'city.board.title': '奖励板',
  'city.arrive.rooftops': '你把自己拉到屋顶上, 车道在你下面开放, 房屋之间的板块在脚下.',
  'city.arrive.museumRoof': '你把旧的子抬到博物馆屋顶上,太阳路广场就像一个游戏板一样.',
  'city.crier.title': '喊者的床单',
  'city.crier.today': '今天是 {name}.',
  'city.crier.tomorrow': '{name} 这就是明天.',
  'city.crier.coming': '{name} 在 {n} 几天.',
  'city.crier.stalls': '在早晨的摊位上:',
  'city.crier.notices': '{n} 在奖励板上有通知.',
  'city.crier.talk': '谈到这个城市:',
  'city.crier.now': '现在正在城市发生的事情:',
  'city.board.empty': '今天没有什么问题,明天再检查.',
  'city.board.posted': '发表于 {name}.',
  'city.board.postedAt': '发表于 {name}, 现在在 {place}.',
  'city.board.days': '{n} 剩下几天.',
  'city.board.find': '找他们',
  'city.topics.ask': '{word}?',
  'city.talkWith': '谈论 {name}',
  'city.journal': '期刊',
  'city.journalNone': '没有什么写到.',
  'city.quests': '连线和线',
  'city.questNone': '现在还没有,跟别人说话.',
  'city.rest': '休息 {n} 分钟',
  'city.saves.title': '保存的游戏',
  'city.saves.slot': '机场 {n}: {day} {time}, {place}',
  'city.saves.empty': '开口 {n}:空',
  'city.saves.save': '在这里保存',
  'city.saves.load': '负载',
  'city.saves.sure': '再击确认',
  'city.saves.hint': '一个救援把整个城市保持在现实状态:你在哪里,时间,人们,任务和胸部.',
  'city.restHint': '你只能在一个小时内休息这么多.',
  'city.bed.ask': '睡着吧. {bed}?',
  'city.bed.night': '你睡着了8个小时, 并且你依据游戏规则休息.',
  'city.bed.sleep': '睡觉',
  'city.bed.notNow': '现在不是',
  'city.bed.tired': '你还没有疲,你可以再睡觉. {n} 几个小时.',
  'city.bed.asleep': '睡着了,夜晚过去了.',
  'city.bed.offer': '睡在这里.',
  'city.vitals': '卫生',
  'city.bed.woke': '你睡着了. {bed} 醒来的时候, {time}. {change}',
  'city.bed.change': '{label}: {before} 在 {after}.',
  'city.bed.noRest': '其他 {system} 规则没有恢复休息,所以没有什么可以修复.',
  'city.bed.beds': '床',
  'city.bed.demoRules': '床试验规则: {system}. 添加"规则"或"鼠标"到这个地址,尝试另一个.',
  'city.messages': '备忘录',
  'city.rules': '游戏系统',
  'city.rulesNarrative': '没有规则:城市作为一个故事. 选择一个系统来看到每个人都在它的数字.',
  'city.statsFor': '对于',
  'city.sparTitle': '练习战斗',
  'city.sparA': '第一个战士',
  'city.sparB': '第二架战斗机',
  'city.sparVs': '反对',
  'city.sparRun': '战斗',
  'city.sparNote': '在这个系统中,没有人受伤.',
  'city.sparRound': '圆形 {n}.',
  'city.zoomIn': '放大',
  'city.pivot.left': '向左旋转视角',
  'city.pivot.right': '向右旋转视角',
  'city.pivot.north': '朝向北方',
  'city.zoomOut': '放大',
  'city.centre': '集中在我身上.',
  'city.followOn': '继续下去',
  'city.followOff': '继续下去',
  'city.followOnHint': '摄像头跟着你,把它开,放开.',
  'city.followOffHint': '在任何地方着,着我,让我回来.',
  'city.minimapShow': '显示地图',
  'city.minimapHide': '隐藏地图',
  'city.minimapOpen': '打开一个更大的城市地图.',
  'city.minimapWalk': '城市地图,点击一个步行地点.',
  'city.minimapSmall': '缩小地图',
  'city.minimapHint': '打点来走到那里.',
  'city.chatter.morning.1.a': '如果你急着,那就在角落烤箱上.',
  'city.chatter.morning.1.b': '我两街前闻到了. 给我节省一块面包.',
  'city.chatter.morning.2.a': '你早起了.',
  'city.chatter.morning.2.b': '钟声唤醒了我,总是这样.',
  'city.chatter.morning.3.a': '车辆从门口进来了吗?',
  'city.chatter.morning.3.b': '他们有三个,一个在桥上失去了轮子.',
  'city.chatter.morning.4.a': '今天早上很冷.',
  'city.chatter.morning.4.b': '到中午,河雾会消灭.',
  'city.chatter.morning.5.a': '你要去哪里?',
  'city.chatter.morning.5.b': '在果消失之前,市场.',
  'city.chatter.afternoon.1.a': '在摊位里有一天繁忙.',
  'city.chatter.afternoon.1.b': '我太忙了,我的脚已经放弃了我.',
  'city.chatter.afternoon.2.a': '你今天见过那个皮器吗?',
  'city.chatter.afternoon.2.b': '一个小时前,他下水.',
  'city.chatter.afternoon.3.a': '今天的太阳是善良的.',
  'city.chatter.afternoon.3.b': '享受它. 雨即将降,我能感觉到它在我的膝盖.',
  'city.chatter.afternoon.4.a': '鱼商人想要什么?',
  'city.chatter.afternoon.4.b': '太多了,我买了胡菜.',
  'city.chatter.afternoon.5.a': '这是一辆新的车?',
  'city.chatter.afternoon.5.b': '轮子仍然像旧一样.',
  'city.chatter.evening.1.a': '你已经回家了吗?',
  'city.chatter.evening.1.b': '晚餐不会自行做饭.',
  'city.chatter.evening.2.a': '灯光正在点燃.',
  'city.chatter.evening.2.b': '然后我又迟到了.',
  'city.chatter.evening.3.a': '今晚你会在酒馆吗?',
  'city.chatter.evening.3.b': '如果我的妻子允许我,是的.',
  'city.chatter.evening.4.a': '一个漫长的日子.',
  'city.chatter.evening.4.b': '他们都在,今年的这个时候.',
  'city.chatter.evening.5.a': '今晚把窗户锁起来.',
  'city.chatter.evening.5.b': '我总是这样做,风不管怎么说都会震动他们.',
  'city.chatter.night.1.a': '谁去那里?',
  'city.chatter.night.1.b': '放下那个灯.',
  'city.chatter.night.2.a': '你应该睡着了.',
  'city.chatter.night.2.b': '你也应该这样做,朋友.',
  'city.chatter.night.3.a': '你在水边听到什么吗?',
  'city.chatter.night.3.b': '猫,总是猫.',
  'city.chatter.night.4.a': '一个安静的夜晚.',
  'city.chatter.night.4.b': '让我们继续这样做.',
  'city.chatter.any.1.a': '你听说过吗?',
  'city.chatter.any.1.b': '什么新闻?总是有新闻.',
  'city.chatter.any.2.a': '祝你一个好日子.',
  'city.chatter.any.2.b': '和你.',
  'city.chatter.any.3.a': '我的表弟发誓,老塔上有鬼.',
  'city.chatter.any.3.b': '你的表妹发誓很多事情.',
  'city.chatter.any.4.a': '价格继续上.',
  'city.chatter.any.4.b': '我的工资一直停留.',
  'city.chatter.any.5.a': '注意那个池.',
  'city.chatter.any.5.b': '太晚了,谢谢你.',
  'city.chatter.any.6.a': '这位陌生人是不是大家都提到的?',
  'city.chatter.any.6.b': '不要着,这是粗鲁的.',
  'city.chatter.any.7.a': '你的母亲怎么样?',
  'city.chatter.any.7.b': '谢谢,她又开始我了.',
  'city.chatter.any.8.a': '我欠你一杯,不是吗?',
  'city.chatter.any.8.b': '两个,根据我的计数.',
  'city.inventory.title': '你的包装',
  'city.inventory.subtitle': 'Montkelian 包包',
  'city.inventory.close': '关闭你的包装',
  'city.inventory.tabs': '包装部分',
  'city.inventory.tab.inventory': '库存',
  'city.inventory.tab.journal': '期刊',
  'city.inventory.tab.map': '地图',
  'city.inventory.empty': '你的包装是空的,你在旅行中发现的东西将被储存在这些口袋里.',
  'city.inventory.slots': '钱包',
  'city.inventory.slotEmpty': '袋子 {n},空',
  'city.inventory.slot.headgear': '头盔',
  'city.inventory.slot.helmet': '头盔',
  'city.inventory.slot.hat': '帽子',
  'city.inventory.slot.hood': '子',
  'city.inventory.slot.amulet': '子',
  'city.inventory.slot.cloak': '子',
  'city.inventory.slot.tabard': '塔巴德',
  'city.inventory.slot.pelt': '皮肤',
  'city.inventory.slot.armor': '装甲',
  'city.inventory.slot.plate': '板块',
  'city.inventory.slot.robe': '服装',
  'city.inventory.slot.jerkin': '狗狗',
  'city.inventory.slot.hide': '隐藏',
  'city.inventory.slot.girdle': '子',
  'city.inventory.slot.belt': '带',
  'city.inventory.slot.bracers': '机',
  'city.inventory.slot.gloves': '套套',
  'city.inventory.slot.mainHand': '主手',
  'city.inventory.slot.offHand': '没有用',
  'city.inventory.slot.twoHand': '两手',
  'city.inventory.slot.sword': '剑',
  'city.inventory.slot.shield': '盾牌',
  'city.inventory.slot.staff': '工作人员',
  'city.inventory.slot.focus': '专注',
  'city.inventory.slot.ring': '戒指',
  'city.inventory.slot.leggings': '子',
  'city.inventory.slot.greaves': '格雷夫斯',
  'city.inventory.slot.boots': '靴子',
  'city.inventory.item.sword': '剑',
  'city.inventory.item.shield': '盾牌',
  'city.inventory.item.knife': '刀子',
  'city.inventory.item.axe': '斧头',
  'city.inventory.item.tabard': '塔巴德',
  'city.inventory.item.cape': '开普',
  'city.inventory.item.ring': '戒指',
  'city.inventory.class.default': '旅行者',
  'city.inventory.class.fighter': '战斗机',
  'city.inventory.class.paladin': '子',
  'city.inventory.class.berserker': '贝尔塞克',
  'city.inventory.class.wizard': '巫师',
  'city.inventory.class.rogue': '恶人',
  'city.inventory.slotFree': '没有任何东西',
  'city.inventory.gear': '你穿着什么',
  'city.inventory.view': '表演',
  'city.inventory.viewGear': '磨损',
  'city.inventory.viewPockets': '钱包',
  'city.inventory.avatarHint': '在"阿瓦达"下,从菜单中选择一个不同的形.',
  'city.inventory.soon.journal': '你的日记暂时是空白的. 你收集的任务和笔记将在这里写.',
  'city.inventory.soon.map': '您的折叠地图将在这里保存,',
  'city.inventory.hint': '打动自己打开包装',
  'city.avatar': '亚凡达',
  'city.avatarLabel': '选择你的形.',
  'city.avatar.robot': '机器人',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': '帕拉丁',
  'city.avatarCloth': '布料',
  'city.avatarClothHint': '随着你的移动,帽子和子摆动',
  'city.soundOn': '启动声音',
  'city.soundOff': '关闭声音',
  'city.musicOn': '播放音乐',
  'city.musicOff': '停止音乐',
  'city.walkSpeed': '速度',
  'city.walkSpeedLabel': '步行速度',
  'city.walkSpeedValue': '{n}x',
  'city.me': '我',
  'city.quality': '质量',
  'city.qualityAuto': '自动 ({tier})',
  'city.tier.low': '低水平',
  'city.tier.medium': '平均值',
  'city.tier.high': '高级',
  'city.robot.keys': '机器人钥匙',
  'city.robot.title': '机器人钥匙',
  'city.robot.intro': '你的机器人会把它放出来,让所有人看到. 它只是为了展示,',
  'city.robot.close': '接近',
  'city.robot.jumpNote': '在空中,再按太空.',
  'city.robot.spellNote': '在咒语模式下, 1, 2 和 3 投放而不是攻击. 投放速度快; 投放咒语首先充电.',
  'city.robot.climbNote': '登上楼梯,登下楼梯,爬上最靠近的道,也可以走上楼梯或上楼梯.',
  'city.robot.walkNote': '走向北,西,南,东,一步一步.拿着钥匙继续走.箭头钥匙做同样.',
  'city.robot.walk.north': '走向北',
  'city.robot.walk.west': '走向西',
  'city.robot.walk.south': '走向南',
  'city.robot.walk.east': '走向东方',
  'city.stairs.label': '走上楼梯',
  'city.stairs.up': '升起',
  'city.stairs.down': '下面',
  'city.stairs.goUp': '爬上一个楼层',
  'city.stairs.goDown': '走下一个楼层',
  'city.robot.toggleNote': '武器模式,咒语模式,潜伏,舞蹈和下降,直到你再次按下它们.',
  'city.robot.typing': '在你打字盒子时,钥匙什么都不做.',
  'city.robot.inSpell': '语法模式: {act}',
  'city.robot.otherwise': '否则: {act}',
  'city.robot.pad': '行动',
  'city.robot.padShow': '显示动作板',
  'city.robot.padHide': '隐藏动作板',
  'city.robot.padTouch': '(用于触摸屏)',
  'city.robot.noLadder': '附近没有楼梯或梯子',
  'city.robot.act.jump': '跳跃',
  'city.robot.act.double-jump': '两次跳跃',
  'city.robot.act.dodge': '逃离',
  'city.robot.act.block': '阻或防御',
  'city.robot.act.parry': '帕里',
  'city.robot.act.weapon-mode': '武器模式',
  'city.robot.act.spell-mode': '术语模式',
  'city.robot.act.slash': '切片',
  'city.robot.act.thrust': '推力',
  'city.robot.act.flurry': '风',
  'city.robot.act.cast': '演员',
  'city.robot.act.cast-spell': '抛弃的咒语',
  'city.robot.act.megacast': '超级广播',
  'city.robot.act.duck': '子',
  'city.robot.act.sneak': '偷',
  'city.robot.act.sing': '唱歌',
  'city.robot.act.dance': '舞蹈',
  'city.robot.act.barf': '气味',
  'city.robot.act.fall': '跌倒或站起来',
  'city.robot.act.climb-up': '爬上',
  'city.robot.act.climb-down': '爬下去',
  'city.robot.act.hurt': '拿一个击球',
  'city.robot.act.kneel': '跪下,站起来',
  'city.robot.act.bow': '鞠躬',
  'city.robot.act.cheer': '欢呼胜利',
  'city.panelShow': '显示板',
  'city.phone.menu': '菜单',
  'city.phone.close': '关闭菜单',
  'city.phone.view': '地图',
  'city.phone.sound': '声音和节奏',
  'city.phone.people': '找一个人',
  'city.phone.more': '其他一切',
  'city.phone.hint': '击地面,让你走路.击一个人,让你说话.',
  'city.phone.gotIt': '得到了.',
  'city.panelHide': '隐藏面板',
  'city.canvasLabel3d': '地图 {city} 在一个角度上看. 拉看周围,点击或滚动到放大,点击到走或说话. 面板列出了每个人都在这里.',
  'city.dock.label': '人们要找到',
  'city.dock.go': '走到这里 {name}',
  'city.dock.walking': '步行到 {name}',
  'city.dock.toPlace': '步行到 {name} 在 {place}',
  'city.dock.cancel': '击地面以停止',
  'city.rigDebug.open': '如何调试 {name} 动作',
  'city.rigDebug.title': '机器调试: {name}',
  'city.rigDebug.close': '接近',
  'city.rigDebug.move': '移动',
  'city.rigDebug.facing': '面对面',
  'city.rigDebug.allMoves': '所有的动作',
  'city.rigDebug.allFacings': '所有面孔',
  'city.rigDebug.cycling': '骑自行车,每一个 {s}',
  'city.rigDebug.play': '玩游戏',
  'city.rigDebug.pause': '暂停',
  'city.rigDebug.back': '退一步一个框架',
  'city.rigDebug.forward': '一步向前,一个框架',
  'city.rigDebug.speed': '速度',
  'city.rigDebug.hint': '暂停一步一步,按下外面或按下逃离,才能关闭.',
  'city.rigDebug.anim.idle': '无事',
  'city.rigDebug.anim.walk': '走路',
  'city.rigDebug.debug': '调试',
  'city.rigDebug.viewLabel': '视图',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': '均仪表',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': '面向 {dir}',
  'city.rigDebug.cell': '排 {row},框架 {col}',
  'city.rigDebug.loading': '装载',
  'city.rigDebug.clip': '剪辑',
  'city.rigDebug.allClips': '所有剪辑',
  'city.rigDebug.noClips': '没有剪辑',
  'city.rigDebug.layers': '表演',
  'city.rigDebug.show.model': '模型',
  'city.rigDebug.show.bones': '骨头',
  'city.rigDebug.show.pieces': '零件',
  'city.rigDebug.boneCount': '{n} 骨头',
  'city.rigDebug.no3d': '在这个屏幕上无法启动3D视图.',
  'city.rigDebug.hint3d': '拖动,转动相机. 暂停,一步一步. 按下外面或按下逃离.',
  'city.rigDebug.standIn': '{name} 显示在 {body} 在她自己的身体准备之前.',
  'city.rigDebug.archive': '档案',
  'city.rigDebug.archivePose': '预览:看看如何 {name} 动作',
  'city.pose.open': '看看如何 {name} 动作',
  'city.pose.robot': '你 (机器人替代)',
  'city.pose.you': '你的',
  'city.pose.see': '看到他们移动',
  'city.pose.youTitle': '你的移动方式',
  'city.pose.openYou': '看看你如何移动',
  'city.pose.title': '如何? {name} 动作',
  'city.pose.allTitle': '所有姿势',
  'city.pose.all': '展示所有姿势',
  'city.pose.one': '只是 {name}',
  'city.pose.close': '接近',
  'city.pose.hint': '敲门外面',
  'city.pose.loading': '装载',
  'city.pose.anim.idle': '无事',
  'city.pose.anim.walk': '走路',
  'city.pose.anim.talk': '谈话',
  'city.pose.anim.sit': '坐下来',
  'city.pose.anim.run': '跑步',
  'city.pose.drag': '拖转转',
  'city.pose.gait': '运动',
  'city.pose.model': '{name} 在3D中',
  'city.pose.dir.SW': '面向西南',
  'city.pose.dir.SE': '面向东南',
  'city.pose.dir.NE': '面向东北',
  'city.pose.dir.NW': '面向西北',
  'city.demoLink': '打开染器演示',
  'city.demoTitle': '发射器演示',
  'city.demoNote': '在这里没有什么能与游戏服务器交谈.',
  'city.demoTime': '日间时间',
  'city.demoSeason': '季节',
  'city.demoPlay': '运行时间',
  'city.demoPause': '停止时间',
  'city.demoTower': '测试塔',
  'city.demoTowerNote': '房间内面有四层楼,可以检查室内景象.里面的楼层被切除,任何你站着的地方看不到的东西都被灰色化.',
  'city.demoGoTower': '走到塔楼',
  'city.demoFloor': '楼层: {floor}',
  'city.demoFloor0': '土地',
  'city.demoFloor1': '第二个',
  'city.demoFloor2': '第3号',
  'city.demoFloor3': '第四',
  'city.demoFloor4': '屋顶',
  'city.demoWindow': '第三层窗户',
  'city.demoRoom': '第三层室内室',
  'city.demoUp': '在一层楼上',
  'city.demoDown': '一个楼下',
  'city.makeWay.polite': '抱歉.',
  'city.makeWay.gruff': '你看着你走的地方.',
  'city.makeWay.immovable': '我不会移动.',
  'city.makeWay.busy': '警你的路.',
  'cascade.seoTitle': '防水清除器',
  'cascade.title': '防水清除器',
  'cascade.intro': '每个提示都产生了艺术,将其设置为两个家族树.风格侧从系统到艺术总监.继承者侧是整个分类,从每个碎片根到物种和它们上的血统. 打开任何一行阅读其完整文本.',
  'cascade.readOnly': '只有阅读,这个屏幕上的任何东西都不能改变提示.',
  'cascade.fetchedAt': '阅读内容API {time}',
  'cascade.refresh': '再次阅读',
  'cascade.loading': '阅读两个布...',
  'cascade.error': '我无法读取内容API中的落.',
  'cascade.forbidden': '这个屏幕是网站管理员的.您的帐户登录,但没有管理员角色.',
  'cascade.style.title': '风格布',
  'cascade.style.subtitle': '系统,出版商,产品线,设置,媒体类型,书籍和艺术总监.',
  'cascade.style.focus': '随着链接',
  'cascade.style.counts': '{nodes} 风格行, {edges} 连接, {media} 媒体模板',
  'cascade.taxa.title': '继承人',
  'cascade.taxa.subtitle': '每个节点都将自己的提示添加到它从上面的节点中继承的所有东西.',
  'cascade.taxa.group': '快速组',
  'cascade.taxa.find': '找出一个类型或血统',
  'cascade.taxa.findPlaceholder': '霍莫,特拉纳,一个血统的名字...',
  'cascade.taxa.counts': '{taxa} 类型, {prompts} 类别, {lineages} 类系',
  'cascade.taxa.shardCounts': '{taxa} taxa, {prompts} 提示行',
  'cascade.taxa.truncated': '内容 API 封闭了这个分片的提示列表,所以这里可能缺少一些行.',
  'cascade.taxa.emptyShards': '尚未有类的碎片: {names}',
  'cascade.taxa.orphans': '那些指向一个没有树的类型',
  'cascade.taxa.noOwn': '这群人没有自己的提示.',
  'cascade.taxa.inherits': '上面的遗产',
  'cascade.taxa.inheritsNothing': '没有遗传,这就是链接的开始.',
  'cascade.taxa.through': '通过这个节点组成',
  'cascade.taxa.lineages': '这种物种的血统',
  'cascade.level.system': '系统',
  'cascade.level.publisher': '出版商',
  'cascade.level.product_line': '产品线',
  'cascade.level.setting': '设置',
  'cascade.level.media': '媒体类型',
  'cascade.level.book': '书籍',
  'cascade.level.art_director': '艺术总监',
  'cascade.empty.system': '在这个链上没有系统风格排列.',
  'cascade.empty.publisher': '没有出版商风格排行,这个层面是空的.',
  'cascade.empty.product_line': '在这个链上没有产品线风格排行.',
  'cascade.empty.setting': '在这个链上没有设置风格排列.',
  'cascade.empty.media': '对于此链,没有媒体类型的模板适用于.',
  'cascade.empty.book': '没有书籍风格的排行在这个设置上.',
  'cascade.empty.art_director': '没有艺术总监连接到这个链路.',
  'cascade.missing': '缺失水平',
  'cascade.others': '在这个水平上的其他行 ({count})',
  'cascade.mediaSpeciesNote': '{count} 种类模板显示在继承者侧,在其血统下.',
  'cascade.field.id': '标签',
  'cascade.field.scope': '范围',
  'cascade.field.scopeId': '范围ID',
  'cascade.field.group': '集团',
  'cascade.field.mediaType': '媒体类型',
  'cascade.field.prompt': '快速',
  'cascade.field.negative': '负值',
  'cascade.field.defaults': '默认',
  'cascade.field.refs': '参考图像',
  'cascade.field.chars': '{count} 字符',
  'cascade.field.empty': '没有任何东西',
  'cascade.facet.art_direction': '核心',
  'cascade.facet.art_direction_character': '性格',
  'cascade.facet.art_direction_scene': '场景',
  'cascade.facet.art_direction_interface': '接口',
  'cascade.facet.art_direction_cartography': '图形绘制',
  'cascade.facet.art_direction_audiobook': '音频书',
  'cascade.facet.art_direction_movie': '电影',
  'cascade.facet.art_direction_short': '短暂',
  'cascade.facet.art_direction_tvshow': '电视节目',
  'cascade.composed.title': '编制为 {name}',
  'cascade.composed.layers': '宽到窄的层',
  'cascade.composed.preview': '复合图像提示',
  'cascade.composed.previewNote': '在此屏幕上从上面的行列组装在级顺序中:风格核心,字符面,媒体模板,分类特征,然后发电机添加代码的打印线.现场发电机还添加框架和主题文本.',
  'cascade.composed.negative': '复合负',
  'cascade.composed.fromCode': '在代码中添加,没有存储在任何行中',
  'cascade.flags.duplicates': '我说了两次.',
  'cascade.flags.conflicts': '在提示中也出现的负面术语',
  'cascade.flags.none': '没有反复的句子,没有与提示相冲突的负面术语.',
  'cascade.flags.in': '在 {sources}',
  'cascade.source.styleCore': '风格核心',
  'cascade.source.styleCharacter': '风格角色方面面',
  'cascade.source.media': '媒体模板 {scope}',
  'cascade.source.taxon': '类型 {rank} {value}',
  'cascade.source.printSafe': '打印线 (代码)',
  'cascade.rank.domain': '域名',
  'cascade.rank.kingdom': '王国',
  'cascade.rank.phylum': '子',
  'cascade.rank.class': '类',
  'cascade.rank.ordem': '序列',
  'cascade.rank.family': '家庭',
  'cascade.rank.genus': '类型',
  'cascade.rank.species': '种类',
  'cascade.rank.shard': '碎片',
}
